/**
 * Conteúdo base dos Termos de Uso (/termos).
 * Edite aqui para atualizar textos e a data de revisão — sem CMS neste momento.
 */

export const TERMOS_LAST_UPDATED_ISO = '2026-07-28';

/** Formatação pt-BR da data de atualização (fácil de trocar via TERMOS_LAST_UPDATED_ISO). */
export function formatTermosLastUpdated(
  isoDate: string = TERMOS_LAST_UPDATED_ISO,
  locale = 'pt-BR'
): string {
  const parsed = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) return isoDate;
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(parsed);
}

export type TermosSection = {
  id: string;
  navLabel: string;
  title: string;
  paragraphs: string[];
  bullets?: string[];
};

export const TERMOS_INTRO =
  'Estes Termos de Uso estabelecem as condições para acesso e utilização do xat Ajuda. Ao acessar ou utilizar este portal, você concorda em respeitar estas condições.';

export const TERMOS_SECTIONS: TermosSection[] = [
  {
    id: 'sobre',
    navLabel: 'Sobre o xat Ajuda',
    title: '1. Sobre o xat Ajuda',
    paragraphs: [
      'O xat Ajuda é um portal de informações, documentação e suporte relacionado ao ecossistema xat. Nosso objetivo é ajudar usuários a encontrar guias, regras, documentação e recursos que facilitem o uso da plataforma e da comunidade.',
      'O conteúdo publicado aqui é organizado para consulta pública e pode incluir orientações gerais, páginas institucionais e materiais de referência sobre o xat.',
    ],
  },
  {
    id: 'uso-do-conteudo',
    navLabel: 'Uso do conteúdo',
    title: '2. Uso do conteúdo',
    paragraphs: [
      'O conteúdo disponibilizado no xat Ajuda tem finalidade informativa e educacional. Você pode consultar os materiais para uso pessoal, desde que respeite estes Termos e as leis aplicáveis.',
      'Não é permitido reproduzir, modificar ou redistribuir conteúdos do portal de forma que viole direitos autorais, marcas ou outras regras aplicáveis, salvo quando houver autorização expressa ou permissão legal.',
    ],
  },
  {
    id: 'uso-aceitavel',
    navLabel: 'Uso aceitável',
    title: '3. Uso aceitável',
    paragraphs: [
      'Ao utilizar o xat Ajuda, você compromete-se a fazer um uso responsável e respeitoso do portal. Em especial, você não deve:',
    ],
    bullets: [
      'Utilizar o site para atividades ilegais ou que infrinjam direitos de terceiros.',
      'Tentar comprometer, interromper ou prejudicar o funcionamento do portal.',
      'Tentar obter acesso não autorizado a áreas restritas, sistemas ou dados.',
      'Utilizar ferramentas automatizadas de maneira abusiva (por exemplo, sobrecarregar o serviço).',
      'Utilizar o conteúdo do portal para fins que possam prejudicar outros usuários ou a comunidade.',
    ],
  },
  {
    id: 'contas-e-acesso',
    navLabel: 'Contas e acesso',
    title: '4. Contas e acesso',
    paragraphs: [
      'Determinadas funcionalidades futuras ou áreas restritas do portal poderão exigir autenticação. Quando isso existir, o acesso estará sujeito às regras e permissões definidas para cada conta.',
      'O usuário é responsável por manter suas credenciais em segurança e por qualquer atividade realizada através de sua conta, quando aplicável.',
    ],
  },
  {
    id: 'conteudo-e-informacoes',
    navLabel: 'Conteúdo e informações',
    title: '5. Conteúdo e informações',
    paragraphs: [
      'O xat Ajuda busca manter as informações atualizadas e úteis. Ainda assim, conteúdos podem sofrer alterações, correções ou atualizações a qualquer momento.',
      'Informações sobre produtos, funcionalidades, powers, recursos ou serviços relacionados ao xat podem mudar ao longo do tempo. Recomendamos consultar as fontes oficiais quando a decisão depender de dados críticos ou atualizações recentes.',
    ],
  },
  {
    id: 'links-externos',
    navLabel: 'Links externos',
    title: '6. Links externos',
    paragraphs: [
      'O portal pode conter links para sites, serviços ou plataformas de terceiros. Esses links são fornecidos para conveniência e referência.',
      'O xat Ajuda não controla necessariamente esses sites externos. O uso de serviços de terceiros está sujeito aos respectivos termos, políticas e práticas de privacidade.',
    ],
  },
  {
    id: 'disponibilidade',
    navLabel: 'Disponibilidade',
    title: '7. Disponibilidade do serviço',
    paragraphs: [
      'O xat Ajuda pode ficar temporariamente indisponível por manutenção, atualizações, problemas técnicos ou outros fatores fora do nosso controle imediato.',
      'Não garantimos disponibilidade contínua ou ininterrupta do portal. Faremos esforços razoáveis para restaurar o acesso quando houver interrupções.',
    ],
  },
  {
    id: 'propriedade-intelectual',
    navLabel: 'Propriedade intelectual',
    title: '8. Propriedade intelectual',
    paragraphs: [
      'Marcas, nomes, logos, imagens e outros materiais pertencentes a terceiros continuam sendo propriedade de seus respectivos titulares. A menção ou exibição desses elementos no portal não implica transferência de direitos.',
      'O conteúdo produzido especificamente para o xat Ajuda deve ser tratado conforme os direitos aplicáveis. Em caso de dúvida sobre uso ou reprodução, entre em contato pelos canais indicados nestes Termos.',
    ],
  },
  {
    id: 'alteracoes',
    navLabel: 'Alterações',
    title: '9. Alterações destes Termos',
    paragraphs: [
      'Estes Termos de Uso podem ser atualizados periodicamente. Quando houver alterações relevantes, a versão atualizada será publicada nesta página, com a indicação da data da última atualização.',
      'O uso continuado do portal após a publicação de alterações significa que você toma conhecimento da versão vigente disponível em /termos.',
    ],
  },
  {
    id: 'contato',
    navLabel: 'Contato',
    title: '10. Contato',
    paragraphs: [
      'Se tiver dúvidas sobre estes Termos de Uso, utilize os canais de contacto já disponíveis no portal — por exemplo, a página da equipe e as páginas de regras e código de conduta — ou consulte os guias de suporte publicados no xat Ajuda.',
    ],
  },
];
